'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var themeTools = require('@chakra-ui/theme-tools');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _defineStyle, _defineStyle2;
var bg = themeTools.cssVar('tooltip-bg');
var arrowBg = themeTools.cssVar('popper-arrow-bg');
var baseStyle = react.defineStyle((_defineStyle = {}, _defineProperty__default["default"](_defineStyle, bg.variable, "colors.white"), _defineProperty__default["default"](_defineStyle, "bg", [bg.reference]), _defineProperty__default["default"](_defineStyle, arrowBg.variable, [bg.reference]), _defineProperty__default["default"](_defineStyle, "p", 2), _defineProperty__default["default"](_defineStyle, "borderRadius", 'base'), _defineProperty__default["default"](_defineStyle, "fontSize", 'xs'), _defineProperty__default["default"](_defineStyle, "boxShadow", 'lg'), _defineProperty__default["default"](_defineStyle, "maxW", '320px'), _defineProperty__default["default"](_defineStyle, "zIndex", 'tooltip'), _defineStyle));
var variantInverted = react.defineStyle((_defineStyle2 = {}, _defineProperty__default["default"](_defineStyle2, bg.variable, "colors.gray.800"), _defineProperty__default["default"](_defineStyle2, "bg", [bg.reference]), _defineProperty__default["default"](_defineStyle2, arrowBg.variable, [bg.reference]), _defineProperty__default["default"](_defineStyle2, "color", 'white'), _defineStyle2));
var variants = {
  inverted: variantInverted
};
var Tooltip = react.defineStyleConfig({
  baseStyle: baseStyle,
  variants: variants
});
exports["default"] = Tooltip;